import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/home';

export default function FeaturedMovies() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              精选高分影视，不容错过的好片推荐
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-2 right-2 bg-primary-500 text-white text-xs font-semibold px-2 py-0.5 rounded-md">
                  {movie.quality}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center gap-1.5 mb-1">
                    <span className="text-accent-400 text-xs font-semibold flex items-center gap-0.5">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-[10px]"></i>
                      </span>
                      {movie.rating}
                    </span>
                    <span className="text-white/60 text-xs">|</span>
                    <span className="text-white/80 text-xs">{movie.year}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                {movie.category}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}